import React from 'react';
import './BannerItem.css'
const BannerItem = ({ slide }) => {
    const { id, image, title, info, prev, next } = slide;
    return (
        <div id={`slide${id}`} className="carousel-item relative w-full h-2/5">
            <div className="carousel-img w-full h-2/5">
                <img src={image} className="w-full rounded-xl h-2/5"/>
            </div>
            <div className="absolute justify-center items-center w-full top-1/2">
                <h1 className="text-6xl font-bold text-white text-center mb-3">{title}</h1>
                <p className='text-white text-center'>{info}</p>
            </div>
            <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                <a href={`#slide${prev}`} className="btn btn-circle">❮</a>
                <a href={`#slide${next}`} className="btn btn-circle">❯</a>
            </div>
        </div>
    );
};

export default BannerItem;